import { LoginEffects } from './login.effect';

export const effects: any[] = [LoginEffects];

export * from './login.effect';
